module.exports = __webpack_public_path__ + "img/myInitialEle.f908e3a0.svg";